<template>
	<div class="step-form-container">
		<template v-for="field in formFields">
			<template v-if="field.tag === 'input'">
				<b-field :class="'input-holder ' + field.class" :label="field.label" :key="field.index">
					<b-input
						:type="field.type"
						:name="field.name"
						:id="field.name"
						:placeholder="field.placeholder"
						v-model="formData[field.name]"
						@input.native="setField($event, formData, field.name)"
					></b-input>
				</b-field>
			</template>
			<template v-else-if="field.tag === 'textarea'">
				<b-field :class="'input-holder ' + field.class" :label="field.label" :key="field.index">
					<b-input
						:type="field.type"
						:name="field.name"
						:id="field.name"
						:placeholder="field.placeholder"
						v-model="formData[field.name]"
						@input.native="setField($event, formData, field.name)"
					></b-input>
				</b-field>
			</template>
			<template v-else-if="field.tag === 'select'">
				<b-field :key="field.index">
					<b-tooltip :label="field.label" position="is-bottom" type="is-dark">
						<b-select
							:name="field.name"
							:id="field.name"
							v-model="formData[field.name]"
							@change.native="setField($event, formData, field.name)"
							expanded
						>
							<option disabled value>{{field.placeholder}}</option>
							<template v-for="item in field.data">
								<option :key="item.index">{{item}}</option>
							</template>
						</b-select>
					</b-tooltip>
				</b-field>
			</template>
		</template>
	</div>
</template>

<script>
import formFieldsHelper from "@/mixins/formFieldsHelper";

export default {
	props: ["formFields", "formData", "currencySelected"],
	mixins: [formFieldsHelper]
};
</script>

<style lang="scss">
.step-form-container {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 8px 20px;

	.field.input-holder {
		&.input-fullwidth {
			grid-column-start: 1;
			grid-column-end: 3;
		}
		label {
			margin-bottom: 0.35rem !important;
			font-size: 14px;
			font-weight: 600;
			text-align: left;
		}
		p.help {
			position: absolute;
			margin-bottom: 0 !important;
		}
	}

	input,
	select {
		text-align: left;
		overflow: hidden !important;
		border-radius: 8px !important;
		transition: all 0.3s ease;
		&:active,
		&:focus {
			outline: 0 !important;
		}
	}
	input {
		font-family: "Gilroy" !important;
		font-size: 20px !important;
		color: #363636 !important;
		border-radius: 0 !important;
		border-color: #ff790e !important;
		border-left: 2px solid $primary !important;
		padding: 36px 8px !important;

		&::placeholder {
			color: #90a8be !important;
		}
	}
	textarea {
		font-family: "Gilroy Light" !important;
		font-weight: 700 !important;
		&::placeholder {
			color: #90a8be !important;
		}
	}
	.select {
		height: 100%;
		&.is-fullwidth {
			width: 100%;
			height: 55px;
		}
		&:not(.is-multiple):not(.is-loading):hover::after {
			border-color: $primary;
		}
		select {
			height: 100%;
			text-align-last: center;
		}
	}

	@include for-phone-only {
		display: block !important;
		.field.input-holder {
			label {
				margin-bottom: 0.35rem !important;
				font-size: 14px;
				font-weight: 600;
				text-align: left;
			}
		}
		.select select {
			height: 55px;
		}
	}
}
</style>